<template>
    <div class="booth-detail-container">
        <!-- 面包屑导航 -->
        <div class="breadcrumb-container">
            <el-breadcrumb separator-class="el-icon-arrow-right">
                <el-breadcrumb-item :to="{ path: '/Welcome' }">
                    <i class="el-icon-s-home"></i>首页
                </el-breadcrumb-item>
                <el-breadcrumb-item :to="{ path: '/boothList' }">
                    <i class="el-icon-s-shop"></i>展位列表
                </el-breadcrumb-item>
                <el-breadcrumb-item>展位详情</el-breadcrumb-item>
            </el-breadcrumb>
        </div>

        <!-- 主内容卡片 -->
        <el-card class="main-card" shadow="hover" v-loading="loading">
            <!-- 头部操作区域 -->
            <div class="card-header">
                <div class="header-title">
                    <i class="el-icon-s-data"></i>
                    <span>展位详情</span>
                    <el-tag
                            :type="statusTagType"
                            size="medium"
                            style="margin-left: 10px;"
                    >
                        {{ statusText }}
                    </el-tag>
                </div>
                <div class="header-actions">
                    <el-button size="mini" icon="el-icon-edit" @click="handleEdit">编辑</el-button>
                    <el-button size="mini" icon="el-icon-back" @click="goBack">返回</el-button>
                </div>
            </div>

            <!-- 详情内容 -->
            <div class="detail-content">
                <!-- 基本信息 -->
                <div class="detail-section">
                    <div class="section-title">
                        <i class="el-icon-info"></i>基本信息
                    </div>
                    <el-row :gutter="20" class="info-row">
                        <el-col :span="8">
                            <div class="info-item">
                                <label class="info-label">展位名称：</label>
                                <span class="info-value">{{ detailData.title || '-' }}</span>
                            </div>
                        </el-col>
                        <el-col :span="8">
                            <div class="info-item">
                                <label class="info-label">展位编号：</label>
                                <span class="info-value">{{ detailData.booth_number || '-' }}</span>
                            </div>
                        </el-col>
                        <el-col :span="8">
                            <div class="info-item">
                                <label class="info-label">展位面积：</label>
                                <span class="info-value">{{ detailData.area ? detailData.area + '㎡' : '-' }}</span>
                            </div>
                        </el-col>
                    </el-row>
                    <el-row :gutter="20" class="info-row">
                        <el-col :span="8">
                            <div class="info-item">
                                <label class="info-label">展位价格：</label>
                                <span class="info-value price">{{ detailData.price ? '¥' + detailData.price : '-' }}</span>
                            </div>
                        </el-col>
                        <el-col :span="8">
                            <div class="info-item">
                                <label class="info-label">容纳人数：</label>
                                <span class="info-value">{{ detailData.capacity ? detailData.capacity + '人' : '-' }}</span>
                            </div>
                        </el-col>
                        <el-col :span="8">
                            <div class="info-item">
                                <label class="info-label">所属分类：</label>
                                <span class="info-value">
                  <el-tag v-if="detailData.category" size="mini">
                    {{ detailData.category.name }}
                  </el-tag>
                  <span v-else>-</span>
                </span>
                            </div>
                        </el-col>
                    </el-row>
                </div>

                <!-- 展会信息 -->
                <div class="detail-section">
                    <div class="section-title">
                        <i class="el-icon-s-promotion"></i>展会信息
                    </div>
                    <el-row :gutter="20" class="info-row">
                        <el-col :span="12">
                            <div class="info-item">
                                <label class="info-label">所属展会：</label>
                                <span class="info-value">{{ detailData.exhibition ? detailData.exhibition.title : '-' }}</span>
                            </div>
                        </el-col>
                        <el-col :span="12">
                            <div class="info-item">
                                <label class="info-label">展会时间：</label>
                                <span class="info-value">
                  <span v-if="detailData.exhibition && detailData.exhibition.start_time">
                    {{ detailData.exhibition.start_time | dateFormat }} 至
                    {{ detailData.exhibition.end_time | dateFormat }}
                  </span>
                  <span v-else>-</span>
                </span>
                            </div>
                        </el-col>
                    </el-row>
                    <el-row :gutter="20" class="info-row">
                        <el-col :span="24">
                            <div class="info-item">
                                <label class="info-label">展会描述：</label>
                                <span class="info-value">{{ detailData.exhibition ? detailData.exhibition.description : '-' }}</span>
                            </div>
                        </el-col>
                    </el-row>
                </div>

                <!-- 展馆信息 -->
                <div class="detail-section">
                    <div class="section-title">
                        <i class="el-icon-office-building"></i>展馆信息
                    </div>
                    <el-row :gutter="20" class="info-row">
                        <el-col :span="12">
                            <div class="info-item">
                                <label class="info-label">所属展馆：</label>
                                <span class="info-value">{{ detailData.venue ? detailData.venue.title : '-' }}</span>
                            </div>
                        </el-col>
                        <el-col :span="12">
                            <div class="info-item">
                                <label class="info-label">展馆地址：</label>
                                <span class="info-value">{{ detailData.venue ? detailData.venue.address : '-' }}</span>
                            </div>
                        </el-col>
                    </el-row>
                    <el-row :gutter="20" class="info-row">
                        <el-col :span="8">
                            <div class="info-item">
                                <label class="info-label">展馆面积：</label>
                                <span class="info-value">{{ detailData.venue ? detailData.venue.area + '㎡' : '-' }}</span>
                            </div>
                        </el-col>
                        <el-col :span="8">
                            <div class="info-item">
                                <label class="info-label">联系电话：</label>
                                <span class="info-value">{{ detailData.venue ? detailData.venue.phone : '-' }}</span>
                            </div>
                        </el-col>
                        <el-col :span="8">
                            <div class="info-item">
                                <label class="info-label">容纳人数：</label>
                                <span class="info-value">{{ detailData.venue ? detailData.venue.capacity + '人' : '-' }}</span>
                            </div>
                        </el-col>
                    </el-row>
                </div>

                <!-- 展位详情 -->
                <div class="detail-section">
                    <div class="section-title">
                        <i class="el-icon-document"></i>展位详情
                    </div>
                    <el-row :gutter="20" class="info-row">
                        <el-col :span="24">
                            <div class="info-item">
                                <label class="info-label">展位描述：</label>
                                <span class="info-value">{{ detailData.description || '-' }}</span>
                            </div>
                        </el-col>
                    </el-row>
                    <el-row :gutter="20" class="info-row">
                        <el-col :span="24">
                            <div class="info-item">
                                <label class="info-label">配套设施：</label>
                                <div class="facilities-list">
                                    <el-tag
                                            v-for="facility in facilitiesList"
                                            :key="facility.value"
                                            :type="hasFacility(facility.value) ? 'success' : 'info'"
                                            size="small"
                                            style="margin-right: 8px; margin-bottom: 5px;"
                                    >
                                        {{ facility.label }}
                                    </el-tag>
                                </div>
                            </div>
                        </el-col>
                    </el-row>
                </div>

                <!-- 展位图片 -->
                <div class="detail-section" v-if="detailData.images && detailData.images.length > 0">
                    <div class="section-title">
                        <i class="el-icon-picture"></i>展位图片
                    </div>
                    <div class="image-gallery">
                        <el-image
                                v-for="(image, index) in detailData.images"
                                :key="index"
                                :src="image"
                                :preview-src-list="detailData.images"
                                fit="cover"
                                class="gallery-image"
                        ></el-image>
                    </div>
                </div>

                <!-- 平面图 -->
                <div class="detail-section" v-if="detailData.layout_image">
                    <div class="section-title">
                        <i class="el-icon-map-location"></i>平面图位置
                    </div>
                    <div class="layout-image-container">
                        <el-image
                                :src="detailData.layout_image"
                                :preview-src-list="[detailData.layout_image]"
                                fit="contain"
                                class="layout-image"
                        >
                            <div slot="error" class="image-slot">
                                <i class="el-icon-picture-outline"></i>
                            </div>
                        </el-image>
                        <div class="layout-mark" v-if="detailData.position_x && detailData.position_y">
                            <div class="position-marker" :style="{
                left: detailData.position_x + '%',
                top: detailData.position_y + '%'
              }">
                                <i class="el-icon-location"></i>
                                <div class="marker-label">当前展位</div>
                            </div>
                        </div>
                    </div>
                </div>

                <!-- 系统信息 -->
                <div class="detail-section">
                    <div class="section-title">
                        <i class="el-icon-setting"></i>系统信息
                    </div>
                    <el-row :gutter="20" class="info-row">
                        <el-col :span="8">
                            <div class="info-item">
                                <label class="info-label">创建时间：</label>
                                <span class="info-value">{{ detailData.add_time | dateFormat }}</span>
                            </div>
                        </el-col>
                        <el-col :span="8">
                            <div class="info-item">
                                <label class="info-label">更新时间：</label>
                                <span class="info-value">{{ detailData.update_time | dateFormat }}</span>
                            </div>
                        </el-col>
                        <el-col :span="8">
                            <div class="info-item">
                                <label class="info-label">所属商家：</label>
                                <span class="info-value">{{ detailData.shop ? detailData.shop.name : '-' }}</span>
                            </div>
                        </el-col>
                    </el-row>
                </div>
            </div>
        </el-card>
    </div>
</template>

<script>
    import moment from 'moment'

    export default {
        name: "BoothDetail",
        data() {
            return {
                loading: false,
                boothId: null,
                detailData: {},

                // 配套设施列表
                facilitiesList: [
                    { label: '电源插座', value: 'power' },
                    { label: '网络接口', value: 'network' },
                    { label: '灯光照明', value: 'lighting' },
                    { label: '桌椅', value: 'table_chair' },
                    { label: '储物柜', value: 'locker' },
                    { label: '展示架', value: 'display_rack' },
                    { label: '地毯', value: 'carpet' },
                    { label: '空调', value: 'air_conditioning' }
                ]
            };
        },
        computed: {
            statusText() {
                const statusMap = {
                    0: '不可用',
                    1: '可预订',
                    2: '已预订',
                    3: '已售出'
                };
                return statusMap[this.detailData.status] || '未知状态';
            },
            statusTagType() {
                const typeMap = {
                    0: 'info',
                    1: 'success',
                    2: 'warning',
                    3: 'danger'
                };
                return typeMap[this.detailData.status] || 'info';
            }
        },
        created() {
            this.boothId = this.$route.query.id;
            if (this.boothId) {
                this.getBoothDetail();
            } else {
                this.$message.error('展位ID不存在');
                this.goBack();
            }
        },
        filters: {
            // 时间格式化
            dateFormat(add_time) {
                if (!add_time) return "-";
                return moment(add_time * 1000).format("YYYY-MM-DD HH:mm:ss");
            }
        },
        methods: {
            // 获取展位详情
            getBoothDetail() {
                this.loading = true;
                const param = {
                    company_id: sessionStorage.getItem('company_id'),
                    access_token: sessionStorage.getItem('token'),
                    id: this.boothId
                }

                this.$axios.boothDetail(param).then(res => {
                    this.loading = false;
                    if (res.code == 200) {
                        this.detailData = res.data || {};
                    } else {
                        this.$message.error(res.msg || '获取展位详情失败');
                        this.goBack();
                    }
                }).catch(error => {
                    this.loading = false;
                    console.log(error);
                    this.$message.error('获取展位详情失败');
                    this.goBack();
                })
            },

            // 检查是否包含配套设施
            hasFacility(facilityValue) {
                if (!this.detailData.facilities) return false;
                return this.detailData.facilities.includes(facilityValue);
            },

            // 编辑展位
            handleEdit() {
                this.$router.push('/boothForm?id=' + this.boothId);
            },

            // 返回列表
            goBack() {
                this.$router.push('/boothList');
            }
        }
    };
</script>

<style scoped>
    .booth-detail-container {
        padding: 20px;
        background-color: #f5f7fa;
        min-height: calc(100vh - 84px);
    }

    .breadcrumb-container {
        margin-bottom: 20px;
    }

    .main-card {
        border-radius: 8px;
        border: none;
    }

    .card-header {
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding-bottom: 20px;
        border-bottom: 1px solid #ebeef5;
        margin-bottom: 20px;
    }

    .header-title {
        display: flex;
        align-items: center;
        font-size: 18px;
        font-weight: 600;
        color: #303133;
    }

    .header-title i {
        margin-right: 8px;
        color: #409EFF;
    }

    .detail-content {
        max-width: 1200px;
        margin: 0 auto;
    }

    .detail-section {
        margin-bottom: 24px;
        padding: 20px;
        background: #fff;
        border-radius: 8px;
        border: 1px solid #ebeef5;
        position: relative;
    }

    .section-title {
        font-size: 16px;
        font-weight: 600;
        color: #303133;
        margin-bottom: 20px;
        padding-bottom: 10px;
        border-bottom: 1px solid #ebeef5;
        display: flex;
        align-items: center;
    }

    .section-title i {
        margin-right: 8px;
        color: #409EFF;
    }

    .info-row {
        margin-bottom: 16px;
    }

    .info-row:last-child {
        margin-bottom: 0;
    }

    .info-item {
        display: flex;
        align-items: flex-start;
        min-height: 32px;
    }

    .info-label {
        font-weight: 500;
        color: #606266;
        min-width: 100px;
        text-align: right;
        margin-right: 12px;
        line-height: 32px;
    }

    .info-value {
        flex: 1;
        color: #303133;
        line-height: 32px;
        word-break: break-all;
    }

    .info-value.price {
        color: #E6A23C;
        font-weight: 600;
        font-size: 16px;
    }

    .facilities-list {
        display: flex;
        flex-wrap: wrap;
        align-items: center;
    }

    .image-gallery {
        display: grid;
        grid-template-columns: repeat(auto-fill, minmax(200px, 1fr));
        gap: 16px;
        margin-top: 16px;
    }

    .gallery-image {
        width: 100%;
        height: 150px;
        border-radius: 6px;
        cursor: pointer;
        transition: transform 0.3s;
    }

    .gallery-image:hover {
        transform: scale(1.05);
    }

    .layout-image-container {
        position: relative;
        width: 100%;
        max-width: 800px;
        margin: 16px auto 0;
        border: 1px solid #ebeef5;
        border-radius: 6px;
        overflow: hidden;
    }

    .layout-image {
        width: 100%;
        height: 400px;
        display: block;
    }

    .layout-mark {
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        pointer-events: none;
    }

    .position-marker {
        position: absolute;
        transform: translate(-50%, -50%);
        text-align: center;
        z-index: 10;
    }

    .position-marker i {
        font-size: 24px;
        color: #F56C6C;
        animation: pulse 2s infinite;
    }

    .marker-label {
        font-size: 12px;
        color: #F56C6C;
        background: rgba(255, 255, 255, 0.9);
        padding: 2px 6px;
        border-radius: 4px;
        margin-top: 4px;
        white-space: nowrap;
    }

    @keyframes pulse {
        0% {
            transform: scale(1);
        }
        50% {
            transform: scale(1.2);
        }
        100% {
            transform: scale(1);
        }
    }

    .image-slot {
        display: flex;
        justify-content: center;
        align-items: center;
        width: 100%;
        height: 100%;
        background: #f5f7fa;
        color: #909399;
        font-size: 30px;
    }

    /* 响应式调整 */
    @media (max-width: 768px) {
        .booth-detail-container {
            padding: 10px;
        }

        .card-header {
            flex-direction: column;
            align-items: flex-start;
        }

        .header-actions {
            margin-top: 10px;
        }

        .detail-section {
            padding: 15px;
        }

        .info-item {
            flex-direction: column;
            align-items: flex-start;
        }

        .info-label {
            text-align: left;
            margin-bottom: 4px;
            min-width: auto;
        }

        .info-value {
            width: 100%;
        }

        .image-gallery {
            grid-template-columns: repeat(auto-fill, minmax(150px, 1fr));
        }

        .gallery-image {
            height: 120px;
        }

        .layout-image {
            height: 300px;
        }
    }

    /* 打印样式 */
    @media print {
        .booth-detail-container {
            background: white;
            padding: 0;
        }

        .breadcrumb-container,
        .header-actions {
            display: none;
        }

        .detail-section {
            break-inside: avoid;
            border: 1px solid #ddd;
        }
    }
</style>
